import { descendingComparator } from './descendingComparator';

export function objectValueComparator<T>(a: T, b: T, orderBy: keyof T) {
  return descendingComparator(a[orderBy], b[orderBy]);
}
